export const country_state = {
  AU: [
    {
      name: "New South Wales",
      code: "NSW",
    },
    {
      name: "Victoria",
      code: "VIC",
    },
    {
      name: "Queensland",
      code: "QLD",
    },
    {
      name: "Tasmania",
      code: "TAS",
    },
    {
      name: "South Australia",
      code: "SA",
    },
    {
      name: "Western Australia",
      code: "WA",
    },
    {
      name: "Northern Territory",
      code: "NT",
    },
    {
      name: "Australian Capital Territory",
      code: "ACT",
    },
  ],
  IN: [
    {
      name: "Andaman and Nicobar Islands",
      code: "Andaman and Nicobar Islands",
    },
    { name: "Andhra Pradesh", code: "Andhra Pradesh" },
    { name: "Arunachal Pradesh", code: "Arunachal Pradesh" },
    { name: "Assam", code: "Assam" },
    { name: "Bihar", code: "Bihar" },
    { name: "Chandigarh", code: "Chandigarh" },
    { name: "Chhattisgarh", code: "Chhattisgarh" },
    { name: "Dadra and Nagar Haveli", code: "Dadra and Nagar Haveli" },
    { name: "Daman and Diu", code: "Daman and Diu" },
    { name: "Delhi", code: "Delhi" },
    { name: "Goa", code: "Goa" },
    { name: "Gujarat", code: "Gujarat" },
    { name: "Haryana", code: "Haryana" },
    { name: "Himachal Pradesh", code: "Himachal Pradesh" },
    { name: "Jammu and Kashmir", code: "Jammu and Kashmir" },
    { name: "Jharkhand", code: "Jharkhand" },
    { name: "Karnataka", code: "Karnataka" },
    { name: "Kerala", code: "Kerala" },
    { name: "Ladakh", code: "Ladakh" },
    { name: "Lakshadweep", code: "Lakshadweep" },
    { name: "Madhya Pradesh", code: "Madhya Pradesh" },
    { name: "Maharashtra", code: "Maharashtra" },
    { name: "Manipur", code: "Manipur" },
    { name: "Meghalaya", code: "Meghalaya" },
    { name: "Mizoram", code: "Mizoram" },
    { name: "Nagaland", code: "Nagaland" },
    { name: "Odisha", code: "Odisha" },
    { name: "Puducherry", code: "Puducherry" },
    { name: "Punjab", code: "Punjab" },
    { name: "Rajashthan", code: "Rajashthan" },
    { name: "Sikkim", code: "Sikkim" },
    { name: "Tamil Nadu", code: "Tamil Nadu" },
    { name: "Telangana", code: "Telangana" },
    { name: "Tripura", code: "Tripura" },
    { name: "Uttar Pradesh", code: "Uttar Pradesh" },
    { name: "Uttarakhand", code: "Uttarakhand" },
    { name: "West Bengal", code: "West Bengal" },
  ],
  UK: [],
  US: [
    {
      name: "Alabama",
      code: "AL",
    },
    {
      name: "Alaska",
      code: "AK",
    },
    {
      name: "American Samoa",
      code: "AS",
    },
    {
      name: "Arizona",
      code: "AZ",
    },
    {
      name: "Arkansas",
      code: "AR",
    },
    {
      name: "California",
      code: "CA",
    },
    {
      name: "Colorado",
      code: "CO",
    },
    {
      name: "Connecticut",
      code: "CT",
    },
    {
      name: "Delaware",
      code: "DE",
    },
    {
      name: "District Of Columbia",
      code: "DC",
    },
    {
      name: "Federated States Of Micronesia",
      code: "FM",
    },
    {
      name: "Florida",
      code: "FL",
    },
    {
      name: "Georgia",
      code: "GA",
    },
    {
      name: "Guam",
      code: "GU",
    },
    {
      name: "Hawaii",
      code: "HI",
    },
    {
      name: "Idaho",
      code: "ID",
    },
    {
      name: "Illinois",
      code: "IL",
    },
    {
      name: "Indiana",
      code: "IN",
    },
    {
      name: "Iowa",
      code: "IA",
    },
    {
      name: "Kansas",
      code: "KS",
    },
    {
      name: "Kentucky",
      code: "KY",
    },
    {
      name: "Louisiana",
      code: "LA",
    },
    {
      name: "Maine",
      code: "ME",
    },
    {
      name: "Marshall Islands",
      code: "MH",
    },
    {
      name: "Maryland",
      code: "MD",
    },
    {
      name: "Massachusetts",
      code: "MA",
    },
    {
      name: "Michigan",
      code: "MI",
    },
    {
      name: "Minnesota",
      code: "MN",
    },
    {
      name: "Mississippi",
      code: "MS",
    },
    {
      name: "Missouri",
      code: "MO",
    },
    {
      name: "Montana",
      code: "MT",
    },
    {
      name: "Nebraska",
      code: "NE",
    },
    {
      name: "Nevada",
      code: "NV",
    },
    {
      name: "New Hampshire",
      code: "NH",
    },
    {
      name: "New Jersey",
      code: "NJ",
    },
    {
      name: "New Mexico",
      code: "NM",
    },
    {
      name: "New York",
      code: "NY",
    },
    {
      name: "North Carolina",
      code: "NC",
    },
    {
      name: "North Dakota",
      code: "ND",
    },
    {
      name: "Northern Mariana Islands",
      code: "MP",
    },
    {
      name: "Ohio",
      code: "OH",
    },
    {
      name: "Oklahoma",
      code: "OK",
    },
    {
      name: "Oregon",
      code: "OR",
    },
    {
      name: "Palau",
      code: "PW",
    },
    {
      name: "Pennsylvania",
      code: "PA",
    },
    {
      name: "Puerto Rico",
      code: "PR",
    },
    {
      name: "Rhode Island",
      code: "RI",
    },
    {
      name: "South Carolina",
      code: "SC",
    },
    {
      name: "South Dakota",
      code: "SD",
    },
    {
      name: "Tennessee",
      code: "TN",
    },
    {
      name: "Texas",
      code: "TX",
    },
    {
      name: "Utah",
      code: "UT",
    },
    {
      name: "Vermont",
      code: "VT",
    },
    {
      name: "Virgin Islands",
      code: "VI",
    },
    {
      name: "Virginia",
      code: "VA",
    },
    {
      name: "Washington",
      code: "WA",
    },
    {
      name: "West Virginia",
      code: "WV",
    },
    {
      name: "Wisconsin",
      code: "WI",
    },
    {
      name: "Wyoming",
      code: "WY",
    },
  ],
};
